import React from 'react';

import { Item, ListContainer } from './ListGroup.styled';

type ItemType = {
  id: string;
  label: string;
  disabled?: boolean;
  onClick?: () => void;
};

interface IListGroupProps {
  items: ItemType[];
  onClickItem?: (item: ItemType) => void;
}

export function ListGroup({ items, onClickItem }: IListGroupProps) {
  function handleClickItem(item: ItemType) {
    if (item.onClick) {
      item.onClick();
    } else if (onClickItem) {
      onClickItem(item);
    }
  }

  return (
    <ListContainer>
      {items.map((item) => (
        <Item key={item.id} onClick={() => handleClickItem(item)} disabled={item.disabled}>
          {item.label}
        </Item>
      ))}
    </ListContainer>
  );
}
